import {getCookie, getRightPrice, getRightTerm, isDesktop, number_format} from "../helpers";
import Swiper from "swiper";
import {translator} from "../helpers/translator";
import * as $ from "jquery";

export function renderPlaces(WIDGET_DATA, $domElements, isChosenTickets) {
    //считаем размер обертки мест
    //прибавляем к ширине 53px для номера ряда справа
    const renderWidth = WIDGET_DATA.placesRenderSettings.xMax * 24 + 53;
    //к высоте рендера прибавляем высоту статического блока Поле (53px)
    const renderHeight = WIDGET_DATA.placesRenderSettings.yMax * 38 + 53;

    //записываем значения по умолчанию для зума
    $domElements.placesWrapper.data('ticket__places-render-default-width',`${renderWidth}`);
    $domElements.placesWrapper.data('ticket__places-render-default-height',`${renderHeight}`);

    $domElements.placesWrapper.css({'width': `${renderWidth}px`, 'height': `${renderHeight}px`});

    let result = '';
    let rowsResultHTML = '';

    //рендер мест
    for (let i = 0; i < WIDGET_DATA.places.length; i++) {
        const placeId = WIDGET_DATA.places[i].id;
        const placeNumber = WIDGET_DATA.places[i].seat;
        const isAvailable = WIDGET_DATA.places[i].isAvailable;
        const placePrice = WIDGET_DATA.places[i].price;
        const placeRow = WIDGET_DATA.places[i].row;
        const categoryId = WIDGET_DATA.places[i].categoryId;
        const zoneId = WIDGET_DATA.places[i].zoneId;
        let placeX = WIDGET_DATA.places[i].x * 24;
        let placeY = WIDGET_DATA.places[i].y * 38;
        let placeClass = '';

        if (!isAvailable) {
            placeClass = 'ticket-system__choose-places-soled-place'
        }

        result += ` 
            <div class="ticket-system__choose-places-item ${placeClass}"
                 style="background-color: ${WIDGET_DATA.chosenSector.color};left: ${placeX}px;bottom: ${placeY}px"
                 data-ticket__place-id="${placeId}"
                 data-ticket__place-number="${placeNumber}"
                 data-ticket__state="${isAvailable}"
                 data-ticket__row-number="${placeRow}"
                 data-ticket__is-chosen-place="0"
                 data-ticket__is-in-price-bounds="1"
                 data-ticket__prices='${placePrice}'
                 data-ticket__default-x="${placeX}"
                 data-ticket__default-y="${placeY}"
                 data-ticket__category-id="${categoryId}"
                 data-ticket__zone-id="${zoneId}"
            ></div>`

        WIDGET_DATA.placesDOMElements.push(`[data-ticket__place-id="${placeId}"]`);

        //рендер номеров ряда
        //если такой номер уже есть - не отрисовываем
        const rowNumberHTML = `
            <div class="ticket-system__choose-places-row-number"
                        style="right: 0;bottom: ${placeY}px"
                        data-ticket__row-number="${placeRow}"
                        data-ticket__row-default-y="${placeY}"
            >${placeRow}</div>`;

        if (!rowsResultHTML.includes(rowNumberHTML)) {
            rowsResultHTML += rowNumberHTML;
        }
    }

    $domElements.placesWrapper.html(result);
    $domElements.placesRowsWrapper.html(rowsResultHTML);

    //если не десктоп - скроллим главный блок до конца вправо (на случай, если мест сильно больше ширины экрана)
    if (!isDesktop()) {
        $domElements.placesWrapper.scrollLeft(10000);
    }

    //если cookieFlag = true -> отмечаем выбранные места на рендере
    if(isChosenTickets){
        //если есть данные о забронированных местах -> берём их, а не из куки
        if(WIDGET_DATA.userInfo.seatInReserve.length !== 0){
            WIDGET_DATA.userInfo.seatInReserve.forEach(reservedPlace => {
                const cookiePlaceId = reservedPlace.seat;
                const $reservedPlaceOnRender = $(`.ticket-system__choose-places-item[data-ticket__place-id='${reservedPlace.seat}']`);
                const placeNumber = $reservedPlaceOnRender.data('ticket__place-number');
                $reservedPlaceOnRender.addClass('ticket-system__choose-places-chosen-place');
                $reservedPlaceOnRender.html('');
                $reservedPlaceOnRender.text(placeNumber);
                $reservedPlaceOnRender.data('ticket__is-chosen-place', '1');
                $reservedPlaceOnRender.data('ticket__is-in-price-bounds', '1');
                $reservedPlaceOnRender.data('ticket__state', '1');
                $reservedPlaceOnRender.data('ticket__prices', `${reservedPlace.price}`);
                $reservedPlaceOnRender.data('ticket__category-id', `${reservedPlace.categoryId}`);
                $reservedPlaceOnRender.data('ticket__zone-id', `${reservedPlace.zoneId}`);
            })

        }else{
            const cookieChosenPlaces = getCookie('chosen_tickets');
            cookieChosenPlaces.forEach(cookiePlace => {
                const cookiePlaceId = cookiePlace.id;
                const $cookiePlaceOnRender = $(`.ticket-system__choose-places-item[data-ticket__place-id='${cookiePlaceId}']`);
                const placeNumber = $cookiePlaceOnRender.data('ticket__place-number');

                $cookiePlaceOnRender.addClass('ticket-system__choose-places-chosen-place');
                $cookiePlaceOnRender.html('');
                $cookiePlaceOnRender.text(placeNumber);
                $cookiePlaceOnRender.data('ticket__is-chosen-place', '1');
                $cookiePlaceOnRender.data('ticket__is-in-price-bounds', '1');
            });
        }

        //ререндер попапа выбранных мест
        renderTicketsPopup($domElements, WIDGET_DATA);
        $domElements.popupTickets.addClass('ticket-system__popup-tickets-active');
    }

    //если абонемент и есть купленный ранее абонемент
   /* if(isChosenTickets && WIDGET_DATA.isAbonement){
        if(WIDGET_DATA.abonementData.seat){
            const abonementPlaceId = WIDGET_DATA.abonementData.seat;
            const $chosenBeforeAbonementOnRender = $(`.ticket-system__choose-places-item[data-ticket__place-id='${abonementPlaceId}']`);
            const placeNumber = $chosenBeforeAbonementOnRender.data('ticket__place-number');

            $chosenBeforeAbonementOnRender.addClass('ticket-system__choose-places-chosen-place');
            $chosenBeforeAbonementOnRender.html('');
            $chosenBeforeAbonementOnRender.text(placeNumber);
            $chosenBeforeAbonementOnRender.data('ticket__is-chosen-place', '1');
            $chosenBeforeAbonementOnRender.data('ticket__is-in-price-bounds', '1');


        }else if(getCookie('chosen_tickets')){
            const cookieChosenPlaces = getCookie('chosen_tickets');
            cookieChosenPlaces.forEach(cookiePlace => {
                const cookiePlaceId = cookiePlace.id;
                const $cookiePlaceOnRender = $(`.ticket-system__choose-places-item[data-ticket__place-id='${cookiePlaceId}']`);
                const placeNumber = $cookiePlaceOnRender.data('ticket__place-number');

                $cookiePlaceOnRender.addClass('ticket-system__choose-places-chosen-place');
                $cookiePlaceOnRender.html('');
                $cookiePlaceOnRender.text(placeNumber);
                $cookiePlaceOnRender.data('ticket__is-chosen-place', '1');
                $cookiePlaceOnRender.data('ticket__is-in-price-bounds', '1');
            });
        }

        //ререндер попапа выбранных мест
        renderTicketsPopup($domElements, WIDGET_DATA);
        $domElements.popupTickets.addClass('ticket-system__popup-tickets-active');
    }*/
}

export function renderTicketsPopup($domElements, WIDGET_DATA) {
    $domElements.popupTicketsWrapper.removeClass('ticket');
    const $ticketsButton = $('[data-ticket__next-step]');
    const $ticketsCurrentPrice = $ticketsButton.find('.ticket-system__popup-tickets-next-step-button-full-price .ticket-system__popup-tickets-order-current-price');
    const $ticketsFullPrice = $ticketsButton.find('.ticket-system__popup-tickets-next-step-button-full-price .ticket-system__popup-tickets-order-full-price');
    const $ticketsTitle = $('[data-ticket__popup_tickets-title]');
    const $bonusesSwitcher = $('.switcher-gray');

    let ticketsHTML = '';
    let ticketsFullPrice = 0;
    let ticketsCount = 0;
    let priceWithSales = 0;

    if (WIDGET_DATA.chosenTickets.length === 0) {
        $domElements.popupTickets.removeClass('ticket-system__popup-tickets-active');
        $domElements.popupTickets.removeClass('ticket-system__popup-tickets-rolled');
        $domElements.popupTicketsWrapper.empty();


    } else {
        WIDGET_DATA.chosenTickets.forEach(ticket => {
            if (ticket.type === 'ticket') {
                let isTicketWithSale = false;
                let priceHTML = ` <div class="ticket-system__popup-ticket-value-bold">${getRightPlacePrice(+ticket.price)} ₽</div>`;

                if(ticketsCount < WIDGET_DATA.availableDiscountTickets){
                    isTicketWithSale = true;

                    priceHTML = ` <div class="ticket-system__popup-ticket-value-bold">
                                        <span>${getRightPlacePrice(+ticket.price / 2)} ₽</span>
                                        <span class="ticket-system__popup-choose-sector-old-price small-version">${getRightPlacePrice(+ticket.price)}</span>
                                  </div>`;

                    //если есть поле discount - место с reservedTickets, меняем формирование цены
                    if(ticket.discount){
                        priceHTML = ` <div class="ticket-system__popup-ticket-value-bold">
                                        <span>${getRightPlacePrice(+ticket.price)} ₽</span>
                                        <span class="ticket-system__popup-choose-sector-old-price small-version">${getRightPlacePrice(+ticket.price * 2)}</span>
                                  </div>`;
                    }
                }

                ticketsCount++;

                ticketsHTML += `
                    <div class="ticket-system__popup-ticket swiper-slide" data-ticket__with-discount="${isTicketWithSale}" data-ticket__slide-id="${ticket.id}">
                        <div class="ticket-system__popup-ticket-left">
                            <div class="ticket-system__popup-ticket-row">
                                <div class="ticket-system__popup-ticket-text">${translator('Блок',WIDGET_DATA.lang)}</div>
                                <div class="ticket-system__popup-ticket-value">${WIDGET_DATA.chosenSector.name}</div>
                            </div>
                            <div class="ticket-system__popup-ticket-row">
                                <div class="ticket-system__popup-ticket-text">${translator('Ряд',WIDGET_DATA.lang)}</div>
                                <div class="ticket-system__popup-ticket-value">${ticket.rowNumber}</div>
                            </div>
                            <div class="ticket-system__popup-ticket-row">
                                <div class="ticket-system__popup-ticket-text">${translator('Место',WIDGET_DATA.lang)}</div>
                                <div class="ticket-system__popup-ticket-value">${ticket.placeNumber}</div>
                            </div>
                            <div class="ticket-system__popup-ticket-row">
                                <div class="ticket-system__popup-ticket-text">${translator('Цена',WIDGET_DATA.lang)}</div>
                                ${priceHTML}
                            </div>
                        </div>
                        <div class="ticket-system__popup-ticket-middle">
                            <div class="ticket-system__popup-ticket-decorate-circle-top"></div>
                            <div class="ticket-system__popup-ticket-decorate-dash"></div>
                            <div class="ticket-system__popup-ticket-decorate-circle-bottom"></div>
                        </div>
                        <div class="ticket-system__popup-ticket-right">
                            <div class="ticket-system__icon__close"></div>
                        </div>
                    </div>`


                if(isTicketWithSale){
                    //если место с reservedSeats - прибавляем полный price (с инфотеха приходит уже со скидкой)
                    if(ticket.discount){
                        ticketsFullPrice += +ticket.price;

                    }else{
                        ticketsFullPrice += +ticket.price / 2;
                    }

                }else{
                    ticketsFullPrice += +ticket.price;
                }
            }
        })

        //добавляем фейковые билеты, если выбрано меньше 20 мест
        if(WIDGET_DATA.isAbonement){
            if (WIDGET_DATA.chosenTickets.length < WIDGET_DATA.abonementData.limit) {
                for (let i = 0; i < WIDGET_DATA.abonementData.limit - WIDGET_DATA.chosenTickets.length; i++) {
                    ticketsHTML += `
                                <div class="ticket-system__popup--fake-ticket swiper-slide">
                                    <div class="ticket-system__popup-fake-ticket-decorate">
                                        <div class="ticket-system__popup-ticket-decorate-circle-top"></div>
                                        <div class="ticket-system__popup-ticket-decorate-circle-bottom"></div>
                                    </div>
                                </div>
                            `;
                }
            }
        }else{
            if (WIDGET_DATA.chosenTickets.length < 20) {
                for (let i = 0; i < 20 - WIDGET_DATA.chosenTickets.length; i++) {
                    ticketsHTML += `
                                <div class="ticket-system__popup--fake-ticket swiper-slide">
                                    <div class="ticket-system__popup-fake-ticket-decorate">
                                        <div class="ticket-system__popup-ticket-decorate-circle-top"></div>
                                        <div class="ticket-system__popup-ticket-decorate-circle-bottom"></div>
                                    </div>
                                </div>
                            `;
                }
            }
        }

        WIDGET_DATA.currentFullPrice = ticketsFullPrice;

        priceWithSales = ticketsFullPrice;

        $domElements.popupTicketsWrapper.html(ticketsHTML);

        //если есть промокод
        if(WIDGET_DATA.promocodeData.min_value !== null &&
            WIDGET_DATA.promocodeData.min_value <= ticketsFullPrice &&
            WIDGET_DATA.promocodeData.discount_value &&
            WIDGET_DATA.promocodeData.discount_type){

            $('.ticket-system__promocode-activate').addClass('ticket-system__hide');
            $('.ticket-system__promocode-activated-promocode').removeClass('ticket-system__hide');

            if(WIDGET_DATA.promocodeData.discount_type === '%'){
                priceWithSales = priceWithSales - priceWithSales * (WIDGET_DATA.promocodeData.discount_value / 100)

            }else if(WIDGET_DATA.promocodeData.discount_type === '₽'){
                priceWithSales = priceWithSales - WIDGET_DATA.promocodeData.discount_value;
            }

        }else{
            WIDGET_DATA.promocodeData.min_value = null;
            WIDGET_DATA.promocodeData.discount_value = 0;
            WIDGET_DATA.promocodeData.discount_type = '';

            if(WIDGET_DATA.isPromocodesAvailable){
                $('.ticket-system__promocode-activate').removeClass('ticket-system__hide');
            }

            $('.ticket-system__promocode-activated-promocode').addClass('ticket-system__hide');

        }

        // если есть бонусы
        if($bonusesSwitcher.hasClass('active')) {
            priceWithSales = priceWithSales - WIDGET_DATA.bonusesWriteOff;
        }

        if(priceWithSales !== ticketsFullPrice){
            $ticketsFullPrice.removeClass('ticket-system__hide');
            $ticketsFullPrice.text(`${getRightPlacePrice(ticketsFullPrice)}`);
            $ticketsCurrentPrice.text(`${getRightPlacePrice(priceWithSales)} ₽`);

        }else{
            $ticketsFullPrice.addClass('ticket-system__hide');
            $ticketsFullPrice.text(``);
            $ticketsCurrentPrice.text(`${getRightPlacePrice(ticketsFullPrice)} ₽`);
        }

        let chosenPlacesWord = WIDGET_DATA.lang === 'en' ? getRightTerm(+WIDGET_DATA.chosenTickets.length, 'place', 'places', 'places') : getRightTerm(+WIDGET_DATA.chosenTickets.length, 'место', 'места', 'мест');

        $ticketsTitle.text(`${translator('Выбрано',WIDGET_DATA.lang)}: ${WIDGET_DATA.chosenTickets.length} ${chosenPlacesWord}`);

        initTicketsSwiper();

        function initTicketsSwiper() {
            if (!WIDGET_DATA.isTicketsSwiperInited) {
                $domElements.ticketsSwiper = new Swiper('#ticket-system__popup-tickets-slider', {
                    slidesPerView: 'auto',
                    visibilityFullFit: true,
                    cssWidthAndHeight: true,
                    autoResize: false,
                    a11y: true
                });

            } else {
                $domElements.ticketsSwiper.update();
            }

            WIDGET_DATA.isTicketsSwiperInited = 1;
        }

        function getRightPlacePrice(price){
            //если число целое - возвращаем без разделителей
            if(Number.isInteger(price)){
                return number_format(price,'','',' ' )

                //иначе - с копейками
            }else{
                return number_format(price,2,',',' ' )
            }
        }
    }
}